/* tslint:disable */
/* eslint-disable */
/**
 * qcs-be
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration';
import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  serializeDataIfNeeded,
  setBearerAuthToObject,
  setSearchParams,
  toPathString
} from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';
import { ReferenceDto } from '../../api/models/employees/ReferenceDto';
import { SafetyEquipmentDto } from '../../api/models/invitation/SafetyEquipmentDto';
import { WorkplaceDto } from '../../api/models/workplace/WorkplaceDto';
import { EmergencyDto } from '../../api/models/emergency/EmergencyDto';
import { IssueRemoteTokenRequest } from '../../api/models/auth/IssueRemoteTokenRequest';
import { CreateRiskRequest } from '../../api/models/risk/CreateRiskRequest';
import { RiskDto } from '../../api/models/risk/RiskDto';
import { RiskVersionDto } from '../../api/models/risk/RiskVersionDto';
import { ForgottenPasswordRequest } from '../../api/models/auth/ForgottenPasswordRequest';
import { LoginRequest } from '../../api/models/auth/LoginRequest';
import { RefreshTokenRequest } from '../../api/models/auth/RefreshTokenRequest';
import { FileUploadMediaResponse } from '../../api/models/invitation/FileUploadMediaResponse';

/**
 *
 * @export
 * @interface ApplicationInfoResult
 */
export interface ApplicationInfoResult {
  /**
   *
   * @type {BuildInfo}
   * @memberof ApplicationInfoResult
   */
  build?: BuildInfo;
  /**
   *
   * @type {GitInfo}
   * @memberof ApplicationInfoResult
   */
  git?: GitInfo;
}
/**
 *
 * @export
 * @interface BuildInfo
 */
export interface BuildInfo {
  /**
   *
   * @type {string}
   * @memberof BuildInfo
   */
  artifact?: string;
  /**
   *
   * @type {string}
   * @memberof BuildInfo
   */
  version?: string;
}
/**
 *
 * @export
 * @interface CommitInfoResult
 */
export interface CommitInfoResult {
  /**
   *
   * @type {string}
   * @memberof CommitInfoResult
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CommitInfoResult
   */
  time?: string;
}

/**
 * Pozvánky ve stavu za celou firmu pracoviste
 * @export
 * @interface DashboardInvitationStatsResponse
 */
export interface DashboardInvitationStatsResponse {
  /**
   *
   * @type {number}
   * @memberof DashboardInvitationStatsResponse
   */
  approved?: number;
  /**
   *
   * @type {number}
   * @memberof DashboardInvitationStatsResponse
   */
  inProgress?: number;
  /**
   *
   * @type {number}
   * @memberof DashboardInvitationStatsResponse
   */
  partiallyFilled?: number;
  /**
   *
   * @type {number}
   * @memberof DashboardInvitationStatsResponse
   */
  sent?: number;
  /**
   *
   * @type {number}
   * @memberof DashboardInvitationStatsResponse
   */
  viewed?: number;
}
/**
 *
 * @export
 * @interface DashboardResponse
 */
export interface DashboardResponse {
  /**
   * Povolení ke vstupu
   * @type {number}
   * @memberof DashboardResponse
   */
  allowedToEnter?: number;
  /**
   * Povolení ke vstupu za firmu
   * @type {number}
   * @memberof DashboardResponse
   */
  allowedToEnterCompany?: number;
  /**
   *
   * @type {DashboardInvitationStatsResponse}
   * @memberof DashboardResponse
   */
  companyStats?: DashboardInvitationStatsResponse;
  /**
   *
   * @type {DashboardInvitationStatsResponse}
   * @memberof DashboardResponse
   */
  establishmentStats?: DashboardInvitationStatsResponse;
  /**
   * Mé návštěvy v areálu
   * @type {number}
   * @memberof DashboardResponse
   */
  myPersonsOnPremises?: number;
  /**
   * Aktuální návštěvy v areálu
   * @type {number}
   * @memberof DashboardResponse
   */
  personsOnPremises?: number;
  /**
   * Počet pracovníků na platných pozvánkách
   * @type {number}
   * @memberof DashboardResponse
   */
  totalWorkers?: number;
  /**
   * Platná pozvánka
   * @type {number}
   * @memberof DashboardResponse
   */
  validInvitations?: number;
}
/**
 *
 * @export
 * @interface EmergencyResponseTemplate
 */
export interface EmergencyResponseTemplate {
  /**
   *
   * @type {string}
   * @memberof EmergencyResponseTemplate
   */
  emailContent?: string;
  /**
   *
   * @type {string}
   * @memberof EmergencyResponseTemplate
   */
  smsContent?: string;
}
/**
 *
 * @export
 * @interface GitInfo
 */
export interface GitInfo {
  /**
   *
   * @type {string}
   * @memberof GitInfo
   */
  branch?: string;
  /**
   *
   * @type {CommitInfoResult}
   * @memberof GitInfo
   */
  commit?: CommitInfoResult;
}

/**
 *
 * @export
 * @interface InvitationTypeVisitListResponse
 */
export interface InvitationTypeVisitListResponse {
  /**
   *
   * @type {string}
   * @memberof InvitationTypeVisitListResponse
   */
  company?: string;
  /**
   *
   * @type {string}
   * @memberof InvitationTypeVisitListResponse
   */
  email?: string;
  /**
   *
   * @type {string}
   * @memberof InvitationTypeVisitListResponse
   */
  lastEntry?: string;
  /**
   *
   * @type {string}
   * @memberof InvitationTypeVisitListResponse
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof InvitationTypeVisitListResponse
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof InvitationTypeVisitListResponse
   */
  phone?: string;
  /**
   *
   * @type {string}
   * @memberof InvitationTypeVisitListResponse
   */
  supplierEmployeeId?: string;
  /**
   *
   * @type {string}
   * @memberof InvitationTypeVisitListResponse
   */
  supplierId?: string;
}
/**
 *
 * @export
 * @interface LoginResponse
 */
export interface LoginResponse {
  /**
   *
   * @type {string}
   * @memberof LoginResponse
   */
  accessToken?: string;
  /**
   *
   * @type {string}
   * @memberof LoginResponse
   */
  mediaToken?: string;
  /**
   *
   * @type {string}
   * @memberof LoginResponse
   */
  refreshToken?: string;
}
/**
 *
 * @export
 * @interface PageEmergencyDto
 */
export interface PageEmergencyDto {
  /**
   *
   * @type {Array<EmergencyDto>}
   * @memberof PageEmergencyDto
   */
  content?: Array<EmergencyDto>;
  /**
   *
   * @type {boolean}
   * @memberof PageEmergencyDto
   */
  empty?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageEmergencyDto
   */
  first?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageEmergencyDto
   */
  last?: boolean;
  /**
   *
   * @type {number}
   * @memberof PageEmergencyDto
   */
  number?: number;
  /**
   *
   * @type {number}
   * @memberof PageEmergencyDto
   */
  numberOfElements?: number;
  /**
   *
   * @type {PageableObject}
   * @memberof PageEmergencyDto
   */
  pageable?: PageableObject;
  /**
   *
   * @type {number}
   * @memberof PageEmergencyDto
   */
  size?: number;
  /**
   *
   * @type {Array<SortObject>}
   * @memberof PageEmergencyDto
   */
  sort?: Array<SortObject>;
  /**
   *
   * @type {number}
   * @memberof PageEmergencyDto
   */
  totalElements?: number;
  /**
   *
   * @type {number}
   * @memberof PageEmergencyDto
   */
  totalPages?: number;
}
/**
 *
 * @export
 * @interface PageRiskDto
 */
export interface PageRiskDto {
  /**
   *
   * @type {Array<RiskDto>}
   * @memberof PageRiskDto
   */
  content?: Array<RiskDto>;
  /**
   *
   * @type {boolean}
   * @memberof PageRiskDto
   */
  empty?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageRiskDto
   */
  first?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageRiskDto
   */
  last?: boolean;
  /**
   *
   * @type {number}
   * @memberof PageRiskDto
   */
  number?: number;
  /**
   *
   * @type {number}
   * @memberof PageRiskDto
   */
  numberOfElements?: number;
  /**
   *
   * @type {PageableObject}
   * @memberof PageRiskDto
   */
  pageable?: PageableObject;
  /**
   *
   * @type {number}
   * @memberof PageRiskDto
   */
  size?: number;
  /**
   *
   * @type {Array<SortObject>}
   * @memberof PageRiskDto
   */
  sort?: Array<SortObject>;
  /**
   *
   * @type {number}
   * @memberof PageRiskDto
   */
  totalElements?: number;
  /**
   *
   * @type {number}
   * @memberof PageRiskDto
   */
  totalPages?: number;
}
/**
 *
 * @export
 * @interface PageRiskVersionDto
 */
export interface PageRiskVersionDto {
  /**
   *
   * @type {Array<RiskVersionDto>}
   * @memberof PageRiskVersionDto
   */
  content?: Array<RiskVersionDto>;
  /**
   *
   * @type {boolean}
   * @memberof PageRiskVersionDto
   */
  empty?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageRiskVersionDto
   */
  first?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageRiskVersionDto
   */
  last?: boolean;
  /**
   *
   * @type {number}
   * @memberof PageRiskVersionDto
   */
  number?: number;
  /**
   *
   * @type {number}
   * @memberof PageRiskVersionDto
   */
  numberOfElements?: number;
  /**
   *
   * @type {PageableObject}
   * @memberof PageRiskVersionDto
   */
  pageable?: PageableObject;
  /**
   *
   * @type {number}
   * @memberof PageRiskVersionDto
   */
  size?: number;
  /**
   *
   * @type {Array<SortObject>}
   * @memberof PageRiskVersionDto
   */
  sort?: Array<SortObject>;
  /**
   *
   * @type {number}
   * @memberof PageRiskVersionDto
   */
  totalElements?: number;
  /**
   *
   * @type {number}
   * @memberof PageRiskVersionDto
   */
  totalPages?: number;
}
/**
 *
 * @export
 * @interface PageSafetyEquipmentDto
 */
export interface PageSafetyEquipmentDto {
  /**
   *
   * @type {Array<SafetyEquipmentDto>}
   * @memberof PageSafetyEquipmentDto
   */
  content?: Array<SafetyEquipmentDto>;
  /**
   *
   * @type {boolean}
   * @memberof PageSafetyEquipmentDto
   */
  empty?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageSafetyEquipmentDto
   */
  first?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PageSafetyEquipmentDto
   */
  last?: boolean;
  /**
   *
   * @type {number}
   * @memberof PageSafetyEquipmentDto
   */
  number?: number;
  /**
   *
   * @type {number}
   * @memberof PageSafetyEquipmentDto
   */
  numberOfElements?: number;
  /**
   *
   * @type {PageableObject}
   * @memberof PageSafetyEquipmentDto
   */
  pageable?: PageableObject;
  /**
   *
   * @type {number}
   * @memberof PageSafetyEquipmentDto
   */
  size?: number;
  /**
   *
   * @type {Array<SortObject>}
   * @memberof PageSafetyEquipmentDto
   */
  sort?: Array<SortObject>;
  /**
   *
   * @type {number}
   * @memberof PageSafetyEquipmentDto
   */
  totalElements?: number;
  /**
   *
   * @type {number}
   * @memberof PageSafetyEquipmentDto
   */
  totalPages?: number;
}
/**
 *
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
  /**
   *
   * @type {number}
   * @memberof PageableObject
   */
  offset?: number;
  /**
   *
   * @type {number}
   * @memberof PageableObject
   */
  pageNumber?: number;
  /**
   *
   * @type {number}
   * @memberof PageableObject
   */
  pageSize?: number;
  /**
   *
   * @type {boolean}
   * @memberof PageableObject
   */
  paged?: boolean;
  /**
   *
   * @type {Array<SortObject>}
   * @memberof PageableObject
   */
  sort?: Array<SortObject>;
  /**
   *
   * @type {boolean}
   * @memberof PageableObject
   */
  unpaged?: boolean;
}
/**
 *
 * @export
 * @interface RiskWithFileResponse
 */
export interface RiskWithFileResponse {
  /**
   *
   * @type {ReferenceDto}
   * @memberof RiskWithFileResponse
   */
  approvedBy?: ReferenceDto;
  /**
   *
   * @type {string}
   * @memberof RiskWithFileResponse
   */
  approvedOn?: string;
  /**
   *
   * @type {FileUploadMediaResponse}
   * @memberof RiskWithFileResponse
   */
  file?: FileUploadMediaResponse;
  /**
   *
   * @type {string}
   * @memberof RiskWithFileResponse
   */
  id?: string;
  /**
   *
   * @type {ReferenceDto}
   * @memberof RiskWithFileResponse
   */
  risk?: ReferenceDto;
}
/**
 *
 * @export
 * @interface SingleValueResponseString
 */
export interface SingleValueResponseString {
  /**
   *
   * @type {string}
   * @memberof SingleValueResponseString
   */
  value?: string;
}
/**
 *
 * @export
 * @interface SingleValueResponsestring
 */
export interface SingleValueResponsestring {
  /**
   *
   * @type {string}
   * @memberof SingleValueResponsestring
   */
  value?: string;
}
/**
 *
 * @export
 * @interface SortObject
 */
export interface SortObject {
  /**
   *
   * @type {boolean}
   * @memberof SortObject
   */
  ascending?: boolean;
  /**
   *
   * @type {string}
   * @memberof SortObject
   */
  direction?: string;
  /**
   *
   * @type {boolean}
   * @memberof SortObject
   */
  ignoreCase?: boolean;
  /**
   *
   * @type {string}
   * @memberof SortObject
   */
  nullHandling?: string;
  /**
   *
   * @type {string}
   * @memberof SortObject
   */
  property?: string;
}
/**
 *
 * @export
 * @interface SubmitForgottenPassword
 */
export interface SubmitForgottenPassword {
  /**
   *
   * @type {string}
   * @memberof SubmitForgottenPassword
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof SubmitForgottenPassword
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof SubmitForgottenPassword
   */
  password: string;
  /**
   *
   * @type {string}
   * @memberof SubmitForgottenPassword
   */
  passwordAgain: string;
}

/**
 *
 * @export
 * @interface UserPreferences
 */
export interface UserPreferences {
  /**
   *
   * @type {string}
   * @memberof UserPreferences
   */
  language?: string;
  /**
   *
   * @type {number}
   * @memberof UserPreferences
   */
  pageSize: number;
  /**
   *
   * @type {UserPreferencesPages}
   * @memberof UserPreferences
   */
  settingsCs: UserPreferencesPages;
  /**
   *
   * @type {UserPreferencesPages}
   * @memberof UserPreferences
   */
  settingsEn: UserPreferencesPages;
}
/**
 *
 * @export
 * @interface UserPreferencesPages
 */
export interface UserPreferencesPages {
  /**
   *
   * @type {boolean}
   * @memberof UserPreferencesPages
   */
  supplierEmployeeSeen?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UserPreferencesPages
   */
  supplierEmployeeWorkerSeen?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof UserPreferencesPages
   */
  visitationSeen?: boolean;
}
/**
 *
 * @export
 * @interface WorkplaceDto
 */

/**
 * ActivityApi - axios parameter creator
 * @export
 */
export const ActivityApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * add later
     * @summary Get workplaces where this activity is member of
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWorkplacesForSafetyEquipment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getWorkplacesForSafetyEquipment', 'id', id);
      const localVarPath = `/api/v1/safety-equipments/{id}/workplaces`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ActivityApi - functional programming interface
 * @export
 */
export const ActivityApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ActivityApiAxiosParamCreator(configuration);
  return {
    /**
     * add later
     * @summary Get workplaces where this activity is member of
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getWorkplacesForSafetyEquipment(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkplaceDto>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkplacesForSafetyEquipment(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['ActivityApi.getWorkplacesForSafetyEquipment']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ActivityApi - factory interface
 * @export
 */
export const ActivityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ActivityApiFp(configuration);
  return {
    /**
     * add later
     * @summary Get workplaces where this activity is member of
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWorkplacesForSafetyEquipment(id: string, options?: any): AxiosPromise<Array<WorkplaceDto>> {
      return localVarFp.getWorkplacesForSafetyEquipment(id, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * ActivityApi - object-oriented interface
 * @export
 * @class ActivityApi
 * @extends {BaseAPI}
 */
export class ActivityApi extends BaseAPI {

  /**
   * add later
   * @summary Get workplaces where this activity is member of
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActivityApi
   */
  public getWorkplacesForSafetyEquipment(id: string, options?: RawAxiosRequestConfig) {
    return ActivityApiFp(this.configuration)
      .getWorkplacesForSafetyEquipment(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ActuatorApi - axios parameter creator
 * @export
 */
export const ActuatorApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applicationInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/actuator/info`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ActuatorApi - functional programming interface
 * @export
 */
export const ActuatorApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ActuatorApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async applicationInfo(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicationInfoResult>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.applicationInfo(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['ActuatorApi.applicationInfo']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ActuatorApi - factory interface
 * @export
 */
export const ActuatorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ActuatorApiFp(configuration);
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    applicationInfo(options?: any): AxiosPromise<ApplicationInfoResult> {
      return localVarFp.applicationInfo(options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * ActuatorApi - object-oriented interface
 * @export
 * @class ActuatorApi
 * @extends {BaseAPI}
 */
export class ActuatorApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ActuatorApi
   */
  public applicationInfo(options?: RawAxiosRequestConfig) {
    return ActuatorApiFp(this.configuration)
      .applicationInfo(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * The purpose of this endpoint is to grant access and refresh token for any available user with valid credentials
     * @summary Issue access and refresh token
     * @param {LoginRequest} loginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessToken: async (loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'loginRequest' is not null or undefined
      assertParamExists('accessToken', 'loginRequest', loginRequest);
      const localVarPath = `/api/v1/auth/access`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * The purpose of this endpoint is to grant access and refresh token for any available user with valid refresh token
     * @summary Issue access and refresh token
     * @param {RefreshTokenRequest} refreshTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken: async (refreshTokenRequest: RefreshTokenRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'refreshTokenRequest' is not null or undefined
      assertParamExists('refreshToken', 'refreshTokenRequest', refreshTokenRequest);
      const localVarPath = `/api/v1/auth/refresh`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary issue access token for remote access
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    remoteToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists('remoteToken', 'token', token);
      const localVarPath = `/api/v1/auth/remote`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (token !== undefined) {
        localVarQueryParameter['token'] = token;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
const AuthenticationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration);
  return {
    /**
     * The purpose of this endpoint is to grant access and refresh token for any available user with valid credentials
     * @summary Issue access and refresh token
     * @param {LoginRequest} loginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async accessToken(
      loginRequest: LoginRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.accessToken(loginRequest, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.accessToken']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * The purpose of this endpoint is to grant access and refresh token for any available user with valid refresh token
     * @summary Issue access and refresh token
     * @param {RefreshTokenRequest} refreshTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async refreshToken(
      refreshTokenRequest: RefreshTokenRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(refreshTokenRequest, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.refreshToken']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary issue access token for remote access
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async remoteToken(
      token: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.remoteToken(token, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.remoteToken']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
  };
};
export default AuthenticationApiFp;

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = AuthenticationApiFp(configuration);
  return {
    /**
     * The purpose of this endpoint is to grant access and refresh token for any available user with valid credentials
     * @summary Issue access and refresh token
     * @param {LoginRequest} loginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    accessToken(loginRequest: LoginRequest, options?: any): AxiosPromise<LoginResponse> {
      return localVarFp.accessToken(loginRequest, options).then((request) => request(axios, basePath));
    },
    /**
     * The purpose of this endpoint is to grant access and refresh token for any available user with valid refresh token
     * @summary Issue access and refresh token
     * @param {RefreshTokenRequest} refreshTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: any): AxiosPromise<LoginResponse> {
      return localVarFp.refreshToken(refreshTokenRequest, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary issue access token for remote access
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    remoteToken(token: string, options?: any): AxiosPromise<LoginResponse> {
      return localVarFp.remoteToken(token, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
  /**
   * The purpose of this endpoint is to grant access and refresh token for any available user with valid credentials
   * @summary Issue access and refresh token
   * @param {LoginRequest} loginRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public accessToken(loginRequest: LoginRequest, options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .accessToken(loginRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * The purpose of this endpoint is to grant access and refresh token for any available user with valid refresh token
   * @summary Issue access and refresh token
   * @param {RefreshTokenRequest} refreshTokenRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public refreshToken(refreshTokenRequest: RefreshTokenRequest, options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .refreshToken(refreshTokenRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary issue access token for remote access
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthenticationApi
   */
  public remoteToken(token: string, options?: RawAxiosRequestConfig) {
    return AuthenticationApiFp(this.configuration)
      .remoteToken(token, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary get dashboard data
     * @param {string} id
     * @param {string} [establishmentForStats] Pozvánky ve stavu -  možnost filtrovat na konkrétní provozovnu
     * @param {string} [establishmentForAllowedToEnter] Povolení ke vstupu možnost filtrovat na konkrétní provozovnu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getData: async (
      id: string,
      establishmentForStats?: string,
      establishmentForAllowedToEnter?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getData', 'id', id);
      const localVarPath = `/companies/{id}/dashboard`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (establishmentForStats !== undefined) {
        localVarQueryParameter['establishmentForStats'] = establishmentForStats;
      }

      if (establishmentForAllowedToEnter !== undefined) {
        localVarQueryParameter['establishmentForAllowedToEnter'] = establishmentForAllowedToEnter;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary get dashboard data
     * @param {string} id
     * @param {string} [establishmentForStats] Pozvánky ve stavu -  možnost filtrovat na konkrétní provozovnu
     * @param {string} [establishmentForAllowedToEnter] Povolení ke vstupu možnost filtrovat na konkrétní provozovnu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getData(
      id: string,
      establishmentForStats?: string,
      establishmentForAllowedToEnter?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getData(id, establishmentForStats, establishmentForAllowedToEnter, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['DashboardApi.getData']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = DashboardApiFp(configuration);
  return {
    /**
     *
     * @summary get dashboard data
     * @param {string} id
     * @param {string} [establishmentForStats] Pozvánky ve stavu -  možnost filtrovat na konkrétní provozovnu
     * @param {string} [establishmentForAllowedToEnter] Povolení ke vstupu možnost filtrovat na konkrétní provozovnu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getData(id: string, establishmentForStats?: string, establishmentForAllowedToEnter?: string, options?: any): AxiosPromise<DashboardResponse> {
      return localVarFp.getData(id, establishmentForStats, establishmentForAllowedToEnter, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
  /**
   *
   * @summary get dashboard data
   * @param {string} id
   * @param {string} [establishmentForStats] Pozvánky ve stavu -  možnost filtrovat na konkrétní provozovnu
   * @param {string} [establishmentForAllowedToEnter] Povolení ke vstupu možnost filtrovat na konkrétní provozovnu
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardApi
   */
  public getData(id: string, establishmentForStats?: string, establishmentForAllowedToEnter?: string, options?: RawAxiosRequestConfig) {
    return DashboardApiFp(this.configuration)
      .getData(id, establishmentForStats, establishmentForAllowedToEnter, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EmergencyApi - axios parameter creator
 * @export
 */
export const EmergencyApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * The purpose of this method is to create emergency for given company. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Create emergency
     * @param {string} company
     * @param {EmergencyDto} emergencyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEmergency: async (company: string, emergencyDto: EmergencyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'company' is not null or undefined
      assertParamExists('createEmergency', 'company', company);
      // verify required parameter 'emergencyDto' is not null or undefined
      assertParamExists('createEmergency', 'emergencyDto', emergencyDto);
      const localVarPath = `/companies/{company}/emergencies`.replace(`{${'company'}}`, encodeURIComponent(String(company)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(emergencyDto, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * The purpose of this method is to end emergency for given id. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary End emergency emergency
     * @param {string} emergency
     * @param {EmergencyDto} emergencyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    endEmergency: async (emergency: string, emergencyDto: EmergencyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'emergency' is not null or undefined
      assertParamExists('endEmergency', 'emergency', emergency);
      // verify required parameter 'emergencyDto' is not null or undefined
      assertParamExists('endEmergency', 'emergencyDto', emergencyDto);
      const localVarPath = `/emergencies/{emergency}/end-emergency`.replace(`{${'emergency'}}`, encodeURIComponent(String(emergency)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(emergencyDto, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Export missing persons
     * @summary Export missing persons
     * @param {string} emergency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportEmployeesEmergency: async (emergency: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'emergency' is not null or undefined
      assertParamExists('exportEmployeesEmergency', 'emergency', emergency);
      const localVarPath = `/emergencies/{emergency}/export`.replace(`{${'emergency'}}`, encodeURIComponent(String(emergency)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * The purpose of this method is to provide emergency for given id. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Get emergency
     * @param {string} emergency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findById: async (emergency: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'emergency' is not null or undefined
      assertParamExists('findById', 'emergency', emergency);
      const localVarPath = `/emergencies/{emergency}`.replace(`{${'emergency'}}`, encodeURIComponent(String(emergency)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * The purpose of this method is to delete missing person from the list for given emergency. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Delete missing person from the list
     * @param {string} emergency
     * @param {string} emergencyPerson
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foundPerson: async (emergency: string, emergencyPerson: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'emergency' is not null or undefined
      assertParamExists('foundPerson', 'emergency', emergency);
      // verify required parameter 'emergencyPerson' is not null or undefined
      assertParamExists('foundPerson', 'emergencyPerson', emergencyPerson);
      const localVarPath = `/emergencies/{emergency}/{emergencyPerson}`
        .replace(`{${'emergency'}}`, encodeURIComponent(String(emergency)))
        .replace(`{${'emergencyPerson'}}`, encodeURIComponent(String(emergencyPerson)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary get shareable link for emergency
     * @param {string} emergency
     * @param {IssueRemoteTokenRequest} issueRemoteTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmergencyLink: async (
      emergency: string,
      issueRemoteTokenRequest: IssueRemoteTokenRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'emergency' is not null or undefined
      assertParamExists('getEmergencyLink', 'emergency', emergency);
      // verify required parameter 'issueRemoteTokenRequest' is not null or undefined
      assertParamExists('getEmergencyLink', 'issueRemoteTokenRequest', issueRemoteTokenRequest);
      const localVarPath = `/emergencies/{emergency}/link`.replace(`{${'emergency'}}`, encodeURIComponent(String(emergency)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(issueRemoteTokenRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * ${api.emergency.getEmail.detail}
     * @summary ${api.emergency.getEmail.title}
     * @param {string} company
     * @param {EmergencyDto} emergencyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMessage: async (company: string, emergencyDto: EmergencyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'company' is not null or undefined
      assertParamExists('getMessage', 'company', company);
      // verify required parameter 'emergencyDto' is not null or undefined
      assertParamExists('getMessage', 'emergencyDto', emergencyDto);
      const localVarPath = `/companies/{company}/emergencies/email`.replace(`{${'company'}}`, encodeURIComponent(String(company)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(emergencyDto, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * ${api.emergency.isEnableToCreate.detail}
     * @summary Check if there are not already active emergencies
     * @param {string} company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    isEnabledToCreate: async (company: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'company' is not null or undefined
      assertParamExists('isEnabledToCreate', 'company', company);
      const localVarPath = `/companies/{company}/emergencies/create-enable`.replace(`{${'company'}}`, encodeURIComponent(String(company)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * The purpose of this method is to provide emergencies for given company. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Get all emergencies
     * @param {string} company
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queryEmergency: async (
      company: string,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'company' is not null or undefined
      assertParamExists('queryEmergency', 'company', company);
      const localVarPath = `/companies/{company}/emergencies`.replace(`{${'company'}}`, encodeURIComponent(String(company)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * The purpose of this method is to update emergency for given id. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Update emergency
     * @param {string} emergency
     * @param {EmergencyDto} emergencyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEmergency: async (emergency: string, emergencyDto: EmergencyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'emergency' is not null or undefined
      assertParamExists('updateEmergency', 'emergency', emergency);
      // verify required parameter 'emergencyDto' is not null or undefined
      assertParamExists('updateEmergency', 'emergencyDto', emergencyDto);
      const localVarPath = `/emergencies/{emergency}`.replace(`{${'emergency'}}`, encodeURIComponent(String(emergency)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(emergencyDto, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EmergencyApi - functional programming interface
 * @export
 */
export const EmergencyApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EmergencyApiAxiosParamCreator(configuration);
  return {
    /**
     * The purpose of this method is to create emergency for given company. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Create emergency
     * @param {string} company
     * @param {EmergencyDto} emergencyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createEmergency(
      company: string,
      emergencyDto: EmergencyDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createEmergency(company, emergencyDto, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['EmergencyApi.createEmergency']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * The purpose of this method is to end emergency for given id. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary End emergency emergency
     * @param {string} emergency
     * @param {EmergencyDto} emergencyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async endEmergency(
      emergency: string,
      emergencyDto: EmergencyDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.endEmergency(emergency, emergencyDto, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['EmergencyApi.endEmergency']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * Export missing persons
     * @summary Export missing persons
     * @param {string} emergency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportEmployeesEmergency(
      emergency: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportEmployeesEmergency(emergency, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['EmergencyApi.exportEmployeesEmergency']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * The purpose of this method is to provide emergency for given id. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Get emergency
     * @param {string} emergency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findById(
      emergency: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.findById(emergency, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['EmergencyApi.findById']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * The purpose of this method is to delete missing person from the list for given emergency. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Delete missing person from the list
     * @param {string} emergency
     * @param {string} emergencyPerson
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async foundPerson(
      emergency: string,
      emergencyPerson: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.foundPerson(emergency, emergencyPerson, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['EmergencyApi.foundPerson']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary get shareable link for emergency
     * @param {string} emergency
     * @param {IssueRemoteTokenRequest} issueRemoteTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEmergencyLink(
      emergency: string,
      issueRemoteTokenRequest: IssueRemoteTokenRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleValueResponseString>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEmergencyLink(emergency, issueRemoteTokenRequest, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['EmergencyApi.getEmergencyLink']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * ${api.emergency.getEmail.detail}
     * @summary ${api.emergency.getEmail.title}
     * @param {string} company
     * @param {EmergencyDto} emergencyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMessage(
      company: string,
      emergencyDto: EmergencyDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmergencyResponseTemplate>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMessage(company, emergencyDto, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['EmergencyApi.getMessage']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * ${api.emergency.isEnableToCreate.detail}
     * @summary Check if there are not already active emergencies
     * @param {string} company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async isEnabledToCreate(
      company: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleValueResponsestring>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.isEnabledToCreate(company, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['EmergencyApi.isEnabledToCreate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * The purpose of this method is to provide emergencies for given company. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Get all emergencies
     * @param {string} company
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async queryEmergency(
      company: string,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageEmergencyDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.queryEmergency(company, page, size, sort, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['EmergencyApi.queryEmergency']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * The purpose of this method is to update emergency for given id. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Update emergency
     * @param {string} emergency
     * @param {EmergencyDto} emergencyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateEmergency(
      emergency: string,
      emergencyDto: EmergencyDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateEmergency(emergency, emergencyDto, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['EmergencyApi.updateEmergency']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * EmergencyApi - factory interface
 * @export
 */
export const EmergencyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = EmergencyApiFp(configuration);
  return {
    /**
     * The purpose of this method is to create emergency for given company. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Create emergency
     * @param {string} company
     * @param {EmergencyDto} emergencyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEmergency(company: string, emergencyDto: EmergencyDto, options?: any): AxiosPromise<EmergencyDto> {
      return localVarFp.createEmergency(company, emergencyDto, options).then((request) => request(axios, basePath));
    },
    /**
     * The purpose of this method is to end emergency for given id. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary End emergency emergency
     * @param {string} emergency
     * @param {EmergencyDto} emergencyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    endEmergency(emergency: string, emergencyDto: EmergencyDto, options?: any): AxiosPromise<void> {
      return localVarFp.endEmergency(emergency, emergencyDto, options).then((request) => request(axios, basePath));
    },
    /**
     * Export missing persons
     * @summary Export missing persons
     * @param {string} emergency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportEmployeesEmergency(emergency: string, options?: any): AxiosPromise<File> {
      return localVarFp.exportEmployeesEmergency(emergency, options).then((request) => request(axios, basePath));
    },
    /**
     * The purpose of this method is to provide emergency for given id. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Get emergency
     * @param {string} emergency
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findById(emergency: string, options?: any): AxiosPromise<EmergencyDto> {
      return localVarFp.findById(emergency, options).then((request) => request(axios, basePath));
    },
    /**
     * The purpose of this method is to delete missing person from the list for given emergency. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Delete missing person from the list
     * @param {string} emergency
     * @param {string} emergencyPerson
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    foundPerson(emergency: string, emergencyPerson: string, options?: any): AxiosPromise<void> {
      return localVarFp.foundPerson(emergency, emergencyPerson, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary get shareable link for emergency
     * @param {string} emergency
     * @param {IssueRemoteTokenRequest} issueRemoteTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEmergencyLink(emergency: string, issueRemoteTokenRequest: IssueRemoteTokenRequest, options?: any): AxiosPromise<SingleValueResponseString> {
      return localVarFp.getEmergencyLink(emergency, issueRemoteTokenRequest, options).then((request) => request(axios, basePath));
    },
    /**
     * ${api.emergency.getEmail.detail}
     * @summary ${api.emergency.getEmail.title}
     * @param {string} company
     * @param {EmergencyDto} emergencyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMessage(company: string, emergencyDto: EmergencyDto, options?: any): AxiosPromise<EmergencyResponseTemplate> {
      return localVarFp.getMessage(company, emergencyDto, options).then((request) => request(axios, basePath));
    },
    /**
     * ${api.emergency.isEnableToCreate.detail}
     * @summary Check if there are not already active emergencies
     * @param {string} company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    isEnabledToCreate(company: string, options?: any): AxiosPromise<SingleValueResponsestring> {
      return localVarFp.isEnabledToCreate(company, options).then((request) => request(axios, basePath));
    },
    /**
     * The purpose of this method is to provide emergencies for given company. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Get all emergencies
     * @param {string} company
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queryEmergency(company: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageEmergencyDto> {
      return localVarFp.queryEmergency(company, page, size, sort, options).then((request) => request(axios, basePath));
    },
    /**
     * The purpose of this method is to update emergency for given id. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
     * @summary Update emergency
     * @param {string} emergency
     * @param {EmergencyDto} emergencyDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEmergency(emergency: string, emergencyDto: EmergencyDto, options?: any): AxiosPromise<void> {
      return localVarFp.updateEmergency(emergency, emergencyDto, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * EmergencyApi - object-oriented interface
 * @export
 * @class EmergencyApi
 * @extends {BaseAPI}
 */
export class EmergencyApi extends BaseAPI {
  /**
   * The purpose of this method is to create emergency for given company. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
   * @summary Create emergency
   * @param {string} company
   * @param {EmergencyDto} emergencyDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmergencyApi
   */
  public createEmergency(company: string, emergencyDto: EmergencyDto, options?: RawAxiosRequestConfig) {
    return EmergencyApiFp(this.configuration)
      .createEmergency(company, emergencyDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * The purpose of this method is to end emergency for given id. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
   * @summary End emergency emergency
   * @param {string} emergency
   * @param {EmergencyDto} emergencyDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmergencyApi
   */
  public endEmergency(emergency: string, emergencyDto: EmergencyDto, options?: RawAxiosRequestConfig) {
    return EmergencyApiFp(this.configuration)
      .endEmergency(emergency, emergencyDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Export missing persons
   * @summary Export missing persons
   * @param {string} emergency
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmergencyApi
   */
  public exportEmployeesEmergency(emergency: string, options?: RawAxiosRequestConfig) {
    return EmergencyApiFp(this.configuration)
      .exportEmployeesEmergency(emergency, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * The purpose of this method is to provide emergency for given id. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
   * @summary Get emergency
   * @param {string} emergency
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmergencyApi
   */
  public findById(emergency: string, options?: RawAxiosRequestConfig) {
    return EmergencyApiFp(this.configuration)
      .findById(emergency, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * The purpose of this method is to delete missing person from the list for given emergency. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
   * @summary Delete missing person from the list
   * @param {string} emergency
   * @param {string} emergencyPerson
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmergencyApi
   */
  public foundPerson(emergency: string, emergencyPerson: string, options?: RawAxiosRequestConfig) {
    return EmergencyApiFp(this.configuration)
      .foundPerson(emergency, emergencyPerson, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary get shareable link for emergency
   * @param {string} emergency
   * @param {IssueRemoteTokenRequest} issueRemoteTokenRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmergencyApi
   */
  public getEmergencyLink(emergency: string, issueRemoteTokenRequest: IssueRemoteTokenRequest, options?: RawAxiosRequestConfig) {
    return EmergencyApiFp(this.configuration)
      .getEmergencyLink(emergency, issueRemoteTokenRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * ${api.emergency.getEmail.detail}
   * @summary ${api.emergency.getEmail.title}
   * @param {string} company
   * @param {EmergencyDto} emergencyDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmergencyApi
   */
  public getMessage(company: string, emergencyDto: EmergencyDto, options?: RawAxiosRequestConfig) {
    return EmergencyApiFp(this.configuration)
      .getMessage(company, emergencyDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * ${api.emergency.isEnableToCreate.detail}
   * @summary Check if there are not already active emergencies
   * @param {string} company
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmergencyApi
   */
  public isEnabledToCreate(company: string, options?: RawAxiosRequestConfig) {
    return EmergencyApiFp(this.configuration)
      .isEnabledToCreate(company, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * The purpose of this method is to provide emergencies for given company. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
   * @summary Get all emergencies
   * @param {string} company
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmergencyApi
   */
  public queryEmergency(company: string, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig) {
    return EmergencyApiFp(this.configuration)
      .queryEmergency(company, page, size, sort, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * The purpose of this method is to update emergency for given id. Available to SCOPE_MANAGER_OSAH, MANAGER_WORKPLACE and RECEPTIONIST roles.
   * @summary Update emergency
   * @param {string} emergency
   * @param {EmergencyDto} emergencyDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EmergencyApi
   */
  public updateEmergency(emergency: string, emergencyDto: EmergencyDto, options?: RawAxiosRequestConfig) {
    return EmergencyApiFp(this.configuration)
      .updateEmergency(emergency, emergencyDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * ForgottenPasswordApi - axios parameter creator
 * @export
 */
export const ForgottenPasswordApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {ForgottenPasswordRequest} forgottenPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestForgottenPassword: async (
      forgottenPasswordRequest: ForgottenPasswordRequest,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'forgottenPasswordRequest' is not null or undefined
      assertParamExists('requestForgottenPassword', 'forgottenPasswordRequest', forgottenPasswordRequest);
      const localVarPath = `/forgotten-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(forgottenPasswordRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SubmitForgottenPassword} submitForgottenPassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submitForgottenPassword: async (submitForgottenPassword: SubmitForgottenPassword, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'submitForgottenPassword' is not null or undefined
      assertParamExists('submitForgottenPassword', 'submitForgottenPassword', submitForgottenPassword);
      const localVarPath = `/forgotten-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(submitForgottenPassword, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ForgottenPasswordApi - functional programming interface
 * @export
 */
export const ForgottenPasswordApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ForgottenPasswordApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {ForgottenPasswordRequest} forgottenPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async requestForgottenPassword(
      forgottenPasswordRequest: ForgottenPasswordRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.requestForgottenPassword(forgottenPasswordRequest, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ForgottenPasswordApi.requestForgottenPassword']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {SubmitForgottenPassword} submitForgottenPassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async submitForgottenPassword(
      submitForgottenPassword: SubmitForgottenPassword,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.submitForgottenPassword(submitForgottenPassword, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['ForgottenPasswordApi.submitForgottenPassword']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ForgottenPasswordApi - factory interface
 * @export
 */
export const ForgottenPasswordApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = ForgottenPasswordApiFp(configuration);
  return {
    /**
     *
     * @param {ForgottenPasswordRequest} forgottenPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    requestForgottenPassword(forgottenPasswordRequest: ForgottenPasswordRequest, options?: any): AxiosPromise<void> {
      return localVarFp.requestForgottenPassword(forgottenPasswordRequest, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SubmitForgottenPassword} submitForgottenPassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    submitForgottenPassword(submitForgottenPassword: SubmitForgottenPassword, options?: any): AxiosPromise<void> {
      return localVarFp.submitForgottenPassword(submitForgottenPassword, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * ForgottenPasswordApi - object-oriented interface
 * @export
 * @class ForgottenPasswordApi
 * @extends {BaseAPI}
 */
export class ForgottenPasswordApi extends BaseAPI {
  /**
   *
   * @param {ForgottenPasswordRequest} forgottenPasswordRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ForgottenPasswordApi
   */
  public requestForgottenPassword(forgottenPasswordRequest: ForgottenPasswordRequest, options?: RawAxiosRequestConfig) {
    return ForgottenPasswordApiFp(this.configuration)
      .requestForgottenPassword(forgottenPasswordRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {SubmitForgottenPassword} submitForgottenPassword
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ForgottenPasswordApi
   */
  public submitForgottenPassword(submitForgottenPassword: SubmitForgottenPassword, options?: RawAxiosRequestConfig) {
    return ForgottenPasswordApiFp(this.configuration)
      .submitForgottenPassword(submitForgottenPassword, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
/**
 * MediaApi - axios parameter creator
 * @export
 */
export const MediaApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Delete specific file
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFile: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('deleteFile', 'id', id);
      const localVarPath = `/api/v1/media/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} subdomain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBannerForSubdomain: async (subdomain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'subdomain' is not null or undefined
      assertParamExists('getBannerForSubdomain', 'subdomain', subdomain);
      const localVarPath = `/api/v1/media/{subdomain}/banner`.replace(`{${'subdomain'}}`, encodeURIComponent(String(subdomain)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} fileName
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadFile: async (id: string, fileName: string, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('loadFile', 'id', id);
      // verify required parameter 'fileName' is not null or undefined
      assertParamExists('loadFile', 'fileName', fileName);
      // verify required parameter 'token' is not null or undefined
      assertParamExists('loadFile', 'token', token);
      const localVarPath = `/api/v1/secured-media/{id}/{fileName}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'fileName'}}`, encodeURIComponent(String(fileName)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (token !== undefined) {
        localVarQueryParameter['token'] = token;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} fileName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadUnsecuredFile: async (id: string, fileName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('loadUnsecuredFile', 'id', id);
      // verify required parameter 'fileName' is not null or undefined
      assertParamExists('loadUnsecuredFile', 'fileName', fileName);
      const localVarPath = `/api/v1/media/{id}/{fileName}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'fileName'}}`, encodeURIComponent(String(fileName)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {UnpairDocumentFromEntityActionEnum} action
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unpairDocumentFromEntity: async (
      id: string,
      action: UnpairDocumentFromEntityActionEnum,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('unpairDocumentFromEntity', 'id', id);
      // verify required parameter 'action' is not null or undefined
      assertParamExists('unpairDocumentFromEntity', 'action', action);
      const localVarPath = `/api/v1/unpair-documents/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (action !== undefined) {
        localVarQueryParameter['action'] = action;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} company
     * @param {boolean} secured
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadMedia: async (company: string, secured: boolean, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'company' is not null or undefined
      assertParamExists('uploadMedia', 'company', company);
      // verify required parameter 'secured' is not null or undefined
      assertParamExists('uploadMedia', 'secured', secured);
      // verify required parameter 'file' is not null or undefined
      assertParamExists('uploadMedia', 'file', file);
      const localVarPath = `/api/v1/companies/{company}/media`.replace(`{${'company'}}`, encodeURIComponent(String(company)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (secured !== undefined) {
        localVarQueryParameter['secured'] = secured;
      }

      if (file !== undefined) {
        localVarFormParams.append('file', file as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MediaApi - functional programming interface
 * @export
 */
export const MediaApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MediaApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Delete specific file
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteFile(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFile(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['MediaApi.deleteFile']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} subdomain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getBannerForSubdomain(
      subdomain: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getBannerForSubdomain(subdomain, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['MediaApi.getBannerForSubdomain']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {string} fileName
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async loadFile(
      id: string,
      fileName: string,
      token: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.loadFile(id, fileName, token, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['MediaApi.loadFile']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {string} fileName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async loadUnsecuredFile(
      id: string,
      fileName: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.loadUnsecuredFile(id, fileName, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['MediaApi.loadUnsecuredFile']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {UnpairDocumentFromEntityActionEnum} action
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unpairDocumentFromEntity(
      id: string,
      action: UnpairDocumentFromEntityActionEnum,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.unpairDocumentFromEntity(id, action, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['MediaApi.unpairDocumentFromEntity']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} company
     * @param {boolean} secured
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadMedia(
      company: string,
      secured: boolean,
      file: File,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadMediaResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.uploadMedia(company, secured, file, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['MediaApi.uploadMedia']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * MediaApi - factory interface
 * @export
 */
export const MediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = MediaApiFp(configuration);
  return {
    /**
     *
     * @summary Delete specific file
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteFile(id: string, options?: any): AxiosPromise<void> {
      return localVarFp.deleteFile(id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} subdomain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBannerForSubdomain(subdomain: string, options?: any): AxiosPromise<File> {
      return localVarFp.getBannerForSubdomain(subdomain, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} fileName
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadFile(id: string, fileName: string, token: string, options?: any): AxiosPromise<File> {
      return localVarFp.loadFile(id, fileName, token, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} fileName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loadUnsecuredFile(id: string, fileName: string, options?: any): AxiosPromise<File> {
      return localVarFp.loadUnsecuredFile(id, fileName, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {UnpairDocumentFromEntityActionEnum} action
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unpairDocumentFromEntity(id: string, action: UnpairDocumentFromEntityActionEnum, options?: any): AxiosPromise<void> {
      return localVarFp.unpairDocumentFromEntity(id, action, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} company
     * @param {boolean} secured
     * @param {File} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadMedia(company: string, secured: boolean, file: File, options?: any): AxiosPromise<FileUploadMediaResponse> {
      return localVarFp.uploadMedia(company, secured, file, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * MediaApi - object-oriented interface
 * @export
 * @class MediaApi
 * @extends {BaseAPI}
 */
export class MediaApi extends BaseAPI {
  /**
   *
   * @summary Delete specific file
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MediaApi
   */
  public deleteFile(id: string, options?: RawAxiosRequestConfig) {
    return MediaApiFp(this.configuration)
      .deleteFile(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} subdomain
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MediaApi
   */
  public getBannerForSubdomain(subdomain: string, options?: RawAxiosRequestConfig) {
    return MediaApiFp(this.configuration)
      .getBannerForSubdomain(subdomain, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {string} fileName
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MediaApi
   */
  public loadFile(id: string, fileName: string, token: string, options?: RawAxiosRequestConfig) {
    return MediaApiFp(this.configuration)
      .loadFile(id, fileName, token, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {string} fileName
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MediaApi
   */
  public loadUnsecuredFile(id: string, fileName: string, options?: RawAxiosRequestConfig) {
    return MediaApiFp(this.configuration)
      .loadUnsecuredFile(id, fileName, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {UnpairDocumentFromEntityActionEnum} action
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MediaApi
   */
  public unpairDocumentFromEntity(id: string, action: UnpairDocumentFromEntityActionEnum, options?: RawAxiosRequestConfig) {
    return MediaApiFp(this.configuration)
      .unpairDocumentFromEntity(id, action, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} company
   * @param {boolean} secured
   * @param {File} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MediaApi
   */
  public uploadMedia(company: string, secured: boolean, file: File, options?: RawAxiosRequestConfig) {
    return MediaApiFp(this.configuration)
      .uploadMedia(company, secured, file, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const UnpairDocumentFromEntityActionEnum = {
  Invitation: 'FROM_INVITATION',
  InvitationActivity: 'FROM_INVITATION_ACTIVITY',
} as const;
export type UnpairDocumentFromEntityActionEnum = (typeof UnpairDocumentFromEntityActionEnum)[keyof typeof UnpairDocumentFromEntityActionEnum];

/**
 * RiskApi - axios parameter creator
 * @export
 */
export const RiskApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} company
     * @param {CreateRiskRequest} createRiskRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRisk: async (company: string, createRiskRequest: CreateRiskRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'company' is not null or undefined
      assertParamExists('createRisk', 'company', company);
      // verify required parameter 'createRiskRequest' is not null or undefined
      assertParamExists('createRisk', 'createRiskRequest', createRiskRequest);
      const localVarPath = `/companies/{company}/risks`.replace(`{${'company'}}`, encodeURIComponent(String(company)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(createRiskRequest, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {RiskVersionDto} riskVersionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRiskVersion: async (id: string, riskVersionDto: RiskVersionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('createRiskVersion', 'id', id);
      // verify required parameter 'riskVersionDto' is not null or undefined
      assertParamExists('createRiskVersion', 'riskVersionDto', riskVersionDto);
      const localVarPath = `/risks/{id}/versions`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(riskVersionDto, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary delete risk version
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRiskVersion: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('deleteRiskVersion', 'id', id);
      const localVarPath = `/risk-versions/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} [invitation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRisk: async (id: string, invitation?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getRisk', 'id', id);
      const localVarPath = `/risks/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (invitation !== undefined) {
        localVarQueryParameter['invitation'] = invitation;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRiskVersion: async (id: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getRiskVersion', 'id', id);
      // verify required parameter 'version' is not null or undefined
      assertParamExists('getRiskVersion', 'version', version);
      const localVarPath = `/risks/{id}/versions/{version}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'version'}}`, encodeURIComponent(String(version)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRiskVersionDocument: async (id: string, version: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getRiskVersionDocument', 'id', id);
      // verify required parameter 'version' is not null or undefined
      assertParamExists('getRiskVersionDocument', 'version', version);
      const localVarPath = `/risks/{id}/versions/{version}/document`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'version'}}`, encodeURIComponent(String(version)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRiskVersions: async (
      id: string,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getRiskVersions', 'id', id);
      const localVarPath = `/risks/{id}/versions`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} company
     * @param {string} [q]
     * @param {QueryRisksStateEnum} [state]
     * @param {boolean} [nameOnly]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queryRisks: async (
      company: string,
      q?: string,
      state?: QueryRisksStateEnum,
      nameOnly?: boolean,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'company' is not null or undefined
      assertParamExists('queryRisks', 'company', company);
      const localVarPath = `/companies/{company}/risks`.replace(`{${'company'}}`, encodeURIComponent(String(company)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (q !== undefined) {
        localVarQueryParameter['q'] = q;
      }

      if (state !== undefined) {
        localVarQueryParameter['state'] = state;
      }

      if (nameOnly !== undefined) {
        localVarQueryParameter['nameOnly'] = nameOnly;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {RiskDto} riskDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRisk: async (id: string, riskDto: RiskDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('updateRisk', 'id', id);
      // verify required parameter 'riskDto' is not null or undefined
      assertParamExists('updateRisk', 'riskDto', riskDto);
      const localVarPath = `/risks/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(riskDto, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} version
     * @param {RiskVersionDto} riskVersionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRiskVersion: async (
      id: string,
      version: string,
      riskVersionDto: RiskVersionDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('updateRiskVersion', 'id', id);
      // verify required parameter 'version' is not null or undefined
      assertParamExists('updateRiskVersion', 'version', version);
      // verify required parameter 'riskVersionDto' is not null or undefined
      assertParamExists('updateRiskVersion', 'riskVersionDto', riskVersionDto);
      const localVarPath = `/risks/{id}/versions/{version}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'version'}}`, encodeURIComponent(String(version)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(riskVersionDto, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RiskApi - functional programming interface
 * @export
 */
export const RiskApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RiskApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} company
     * @param {CreateRiskRequest} createRiskRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createRisk(
      company: string,
      createRiskRequest: CreateRiskRequest,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferenceDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createRisk(company, createRiskRequest, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['RiskApi.createRisk']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {RiskVersionDto} riskVersionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createRiskVersion(
      id: string,
      riskVersionDto: RiskVersionDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferenceDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createRiskVersion(id, riskVersionDto, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['RiskApi.createRiskVersion']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary delete risk version
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteRiskVersion(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRiskVersion(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['RiskApi.deleteRiskVersion']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {string} [invitation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRisk(
      id: string,
      invitation?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRisk(id, invitation, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['RiskApi.getRisk']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRiskVersion(
      id: string,
      version: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RiskVersionDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskVersion(id, version, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['RiskApi.getRiskVersion']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRiskVersionDocument(
      id: string,
      version: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskVersionDocument(id, version, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['RiskApi.getRiskVersionDocument']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRiskVersions(
      id: string,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageRiskVersionDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRiskVersions(id, page, size, sort, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['RiskApi.getRiskVersions']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} company
     * @param {string} [q]
     * @param {QueryRisksStateEnum} [state]
     * @param {boolean} [nameOnly]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async queryRisks(
      company: string,
      q?: string,
      state?: QueryRisksStateEnum,
      nameOnly?: boolean,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageRiskDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.queryRisks(company, q, state, nameOnly, page, size, sort, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['RiskApi.queryRisks']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {RiskDto} riskDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRisk(
      id: string,
      riskDto: RiskDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateRisk(id, riskDto, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['RiskApi.updateRisk']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {string} version
     * @param {RiskVersionDto} riskVersionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRiskVersion(
      id: string,
      version: string,
      riskVersionDto: RiskVersionDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateRiskVersion(id, version, riskVersionDto, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['RiskApi.updateRiskVersion']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * RiskApi - factory interface
 * @export
 */
export const RiskApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = RiskApiFp(configuration);
  return {
    /**
     *
     * @param {string} company
     * @param {CreateRiskRequest} createRiskRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRisk(company: string, createRiskRequest: CreateRiskRequest, options?: any): AxiosPromise<ReferenceDto> {
      return localVarFp.createRisk(company, createRiskRequest, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {RiskVersionDto} riskVersionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRiskVersion(id: string, riskVersionDto: RiskVersionDto, options?: any): AxiosPromise<ReferenceDto> {
      return localVarFp.createRiskVersion(id, riskVersionDto, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary delete risk version
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRiskVersion(id: string, options?: any): AxiosPromise<void> {
      return localVarFp.deleteRiskVersion(id, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} [invitation]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRisk(id: string, invitation?: string, options?: any): AxiosPromise<RiskDto> {
      return localVarFp.getRisk(id, invitation, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRiskVersion(id: string, version: string, options?: any): AxiosPromise<RiskVersionDto> {
      return localVarFp.getRiskVersion(id, version, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRiskVersionDocument(id: string, version: string, options?: any): AxiosPromise<File> {
      return localVarFp.getRiskVersionDocument(id, version, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRiskVersions(id: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageRiskVersionDto> {
      return localVarFp.getRiskVersions(id, page, size, sort, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} company
     * @param {string} [q]
     * @param {QueryRisksStateEnum} [state]
     * @param {boolean} [nameOnly]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    queryRisks(
      company: string,
      q?: string,
      state?: QueryRisksStateEnum,
      nameOnly?: boolean,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: any
    ): AxiosPromise<PageRiskDto> {
      return localVarFp.queryRisks(company, q, state, nameOnly, page, size, sort, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {RiskDto} riskDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRisk(id: string, riskDto: RiskDto, options?: any): AxiosPromise<void> {
      return localVarFp.updateRisk(id, riskDto, options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} version
     * @param {RiskVersionDto} riskVersionDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRiskVersion(id: string, version: string, riskVersionDto: RiskVersionDto, options?: any): AxiosPromise<void> {
      return localVarFp.updateRiskVersion(id, version, riskVersionDto, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * RiskApi - object-oriented interface
 * @export
 * @class RiskApi
 * @extends {BaseAPI}
 */
export class RiskApi extends BaseAPI {
  /**
   *
   * @param {string} company
   * @param {CreateRiskRequest} createRiskRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RiskApi
   */
  public createRisk(company: string, createRiskRequest: CreateRiskRequest, options?: RawAxiosRequestConfig) {
    return RiskApiFp(this.configuration)
      .createRisk(company, createRiskRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {RiskVersionDto} riskVersionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RiskApi
   */
  public createRiskVersion(id: string, riskVersionDto: RiskVersionDto, options?: RawAxiosRequestConfig) {
    return RiskApiFp(this.configuration)
      .createRiskVersion(id, riskVersionDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary delete risk version
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RiskApi
   */
  public deleteRiskVersion(id: string, options?: RawAxiosRequestConfig) {
    return RiskApiFp(this.configuration)
      .deleteRiskVersion(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {string} [invitation]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RiskApi
   */
  public getRisk(id: string, invitation?: string, options?: RawAxiosRequestConfig) {
    return RiskApiFp(this.configuration)
      .getRisk(id, invitation, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {string} version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RiskApi
   */
  public getRiskVersion(id: string, version: string, options?: RawAxiosRequestConfig) {
    return RiskApiFp(this.configuration)
      .getRiskVersion(id, version, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {string} version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RiskApi
   */
  public getRiskVersionDocument(id: string, version: string, options?: RawAxiosRequestConfig) {
    return RiskApiFp(this.configuration)
      .getRiskVersionDocument(id, version, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RiskApi
   */
  public getRiskVersions(id: string, page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig) {
    return RiskApiFp(this.configuration)
      .getRiskVersions(id, page, size, sort, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} company
   * @param {string} [q]
   * @param {QueryRisksStateEnum} [state]
   * @param {boolean} [nameOnly]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RiskApi
   */
  public queryRisks(
    company: string,
    q?: string,
    state?: QueryRisksStateEnum,
    nameOnly?: boolean,
    page?: number,
    size?: number,
    sort?: Array<string>,
    options?: RawAxiosRequestConfig
  ) {
    return RiskApiFp(this.configuration)
      .queryRisks(company, q, state, nameOnly, page, size, sort, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {RiskDto} riskDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RiskApi
   */
  public updateRisk(id: string, riskDto: RiskDto, options?: RawAxiosRequestConfig) {
    return RiskApiFp(this.configuration)
      .updateRisk(id, riskDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {string} version
   * @param {RiskVersionDto} riskVersionDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RiskApi
   */
  public updateRiskVersion(id: string, version: string, riskVersionDto: RiskVersionDto, options?: RawAxiosRequestConfig) {
    return RiskApiFp(this.configuration)
      .updateRiskVersion(id, version, riskVersionDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const QueryRisksStateEnum = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
} as const;
export type QueryRisksStateEnum = (typeof QueryRisksStateEnum)[keyof typeof QueryRisksStateEnum];

/**
 * SafetyEquipmentApi - axios parameter creator
 * @export
 */
export const SafetyEquipmentApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * The purpose of this method is to create safety equipment. Available only to SCOPE_MANAGER_OSAH role.
     * @summary Create safety equipment
     * @param {string} company
     * @param {SafetyEquipmentDto} safetyEquipmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSafetyEquipment: async (
      company: string,
      safetyEquipmentDto: SafetyEquipmentDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'company' is not null or undefined
      assertParamExists('createSafetyEquipment', 'company', company);
      // verify required parameter 'safetyEquipmentDto' is not null or undefined
      assertParamExists('createSafetyEquipment', 'safetyEquipmentDto', safetyEquipmentDto);
      const localVarPath = `/api/v1/companies/{company}/safety-equipments`.replace(`{${'company'}}`, encodeURIComponent(String(company)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(safetyEquipmentDto, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * The purpose of this method is to provide safety equipment for given company. Available only to SCOPE_MANAGER_OSAH role.
     * @summary Get safety equipment for given company
     * @param {string} safetyEquipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSafetyEquipment: async (safetyEquipment: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'safetyEquipment' is not null or undefined
      assertParamExists('getSafetyEquipment', 'safetyEquipment', safetyEquipment);
      const localVarPath = `/api/v1/safety-equipments/{safetyEquipment}`.replace(
        `{${'safetyEquipment'}}`,
        encodeURIComponent(String(safetyEquipment))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * The purpose of this method is to provide list of all safety equipments. Available only to SCOPE_MANAGER_OSAH role.
     * @summary Get all safety equipments for given company
     * @param {string} company
     * @param {string} [q]
     * @param {QuerySafetyEquipmentStateEnum} [state]
     * @param {boolean} [nameOnly]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    querySafetyEquipment: async (
      company: string,
      q?: string,
      state?: QuerySafetyEquipmentStateEnum,
      nameOnly?: boolean,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'company' is not null or undefined
      assertParamExists('querySafetyEquipment', 'company', company);
      const localVarPath = `/api/v1/companies/{company}/safety-equipments`.replace(`{${'company'}}`, encodeURIComponent(String(company)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (q !== undefined) {
        localVarQueryParameter['q'] = q;
      }

      if (state !== undefined) {
        localVarQueryParameter['state'] = state;
      }

      if (nameOnly !== undefined) {
        localVarQueryParameter['nameOnly'] = nameOnly;
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter['size'] = size;
      }

      if (sort) {
        localVarQueryParameter['sort'] = sort;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * The purpose of this method is to update safety equipment. Available only to SCOPE_MANAGER_OSAH role.
     * @summary Update safety equipment for given company
     * @param {string} safetyEquipment
     * @param {SafetyEquipmentDto} safetyEquipmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSafetyEquipment: async (
      safetyEquipment: string,
      safetyEquipmentDto: SafetyEquipmentDto,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'safetyEquipment' is not null or undefined
      assertParamExists('updateSafetyEquipment', 'safetyEquipment', safetyEquipment);
      // verify required parameter 'safetyEquipmentDto' is not null or undefined
      assertParamExists('updateSafetyEquipment', 'safetyEquipmentDto', safetyEquipmentDto);
      const localVarPath = `/api/v1/safety-equipments/{safetyEquipment}`.replace(
        `{${'safetyEquipment'}}`,
        encodeURIComponent(String(safetyEquipment))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication qcs_auth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(safetyEquipmentDto, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SafetyEquipmentApi - functional programming interface
 * @export
 */
export const SafetyEquipmentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SafetyEquipmentApiAxiosParamCreator(configuration);
  return {
    /**
     * The purpose of this method is to create safety equipment. Available only to SCOPE_MANAGER_OSAH role.
     * @summary Create safety equipment
     * @param {string} company
     * @param {SafetyEquipmentDto} safetyEquipmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createSafetyEquipment(
      company: string,
      safetyEquipmentDto: SafetyEquipmentDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferenceDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createSafetyEquipment(company, safetyEquipmentDto, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['SafetyEquipmentApi.createSafetyEquipment']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * The purpose of this method is to provide safety equipment for given company. Available only to SCOPE_MANAGER_OSAH role.
     * @summary Get safety equipment for given company
     * @param {string} safetyEquipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSafetyEquipment(
      safetyEquipment: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SafetyEquipmentDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSafetyEquipment(safetyEquipment, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['SafetyEquipmentApi.getSafetyEquipment']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * The purpose of this method is to provide list of all safety equipments. Available only to SCOPE_MANAGER_OSAH role.
     * @summary Get all safety equipments for given company
     * @param {string} company
     * @param {string} [q]
     * @param {QuerySafetyEquipmentStateEnum} [state]
     * @param {boolean} [nameOnly]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async querySafetyEquipment(
      company: string,
      q?: string,
      state?: QuerySafetyEquipmentStateEnum,
      nameOnly?: boolean,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageSafetyEquipmentDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.querySafetyEquipment(company, q, state, nameOnly, page, size, sort, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['SafetyEquipmentApi.querySafetyEquipment']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * The purpose of this method is to update safety equipment. Available only to SCOPE_MANAGER_OSAH role.
     * @summary Update safety equipment for given company
     * @param {string} safetyEquipment
     * @param {SafetyEquipmentDto} safetyEquipmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateSafetyEquipment(
      safetyEquipment: string,
      safetyEquipmentDto: SafetyEquipmentDto,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateSafetyEquipment(safetyEquipment, safetyEquipmentDto, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath = operationServerMap['SafetyEquipmentApi.updateSafetyEquipment']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * SafetyEquipmentApi - factory interface
 * @export
 */
export const SafetyEquipmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = SafetyEquipmentApiFp(configuration);
  return {
    /**
     * The purpose of this method is to create safety equipment. Available only to SCOPE_MANAGER_OSAH role.
     * @summary Create safety equipment
     * @param {string} company
     * @param {SafetyEquipmentDto} safetyEquipmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSafetyEquipment(company: string, safetyEquipmentDto: SafetyEquipmentDto, options?: any): AxiosPromise<ReferenceDto> {
      return localVarFp.createSafetyEquipment(company, safetyEquipmentDto, options).then((request) => request(axios, basePath));
    },
    /**
     * The purpose of this method is to provide safety equipment for given company. Available only to SCOPE_MANAGER_OSAH role.
     * @summary Get safety equipment for given company
     * @param {string} safetyEquipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSafetyEquipment(safetyEquipment: string, options?: any): AxiosPromise<SafetyEquipmentDto> {
      return localVarFp.getSafetyEquipment(safetyEquipment, options).then((request) => request(axios, basePath));
    },
    /**
     * The purpose of this method is to provide list of all safety equipments. Available only to SCOPE_MANAGER_OSAH role.
     * @summary Get all safety equipments for given company
     * @param {string} company
     * @param {string} [q]
     * @param {QuerySafetyEquipmentStateEnum} [state]
     * @param {boolean} [nameOnly]
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    querySafetyEquipment(
      company: string,
      q?: string,
      state?: QuerySafetyEquipmentStateEnum,
      nameOnly?: boolean,
      page?: number,
      size?: number,
      sort?: Array<string>,
      options?: any
    ): AxiosPromise<PageSafetyEquipmentDto> {
      return localVarFp.querySafetyEquipment(company, q, state, nameOnly, page, size, sort, options).then((request) => request(axios, basePath));
    },
    /**
     * The purpose of this method is to update safety equipment. Available only to SCOPE_MANAGER_OSAH role.
     * @summary Update safety equipment for given company
     * @param {string} safetyEquipment
     * @param {SafetyEquipmentDto} safetyEquipmentDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSafetyEquipment(safetyEquipment: string, safetyEquipmentDto: SafetyEquipmentDto, options?: any): AxiosPromise<void> {
      return localVarFp.updateSafetyEquipment(safetyEquipment, safetyEquipmentDto, options).then((request) => request(axios, basePath));
    },
  };
};

/**
 * SafetyEquipmentApi - object-oriented interface
 * @export
 * @class SafetyEquipmentApi
 * @extends {BaseAPI}
 */
export class SafetyEquipmentApi extends BaseAPI {
  /**
   * The purpose of this method is to create safety equipment. Available only to SCOPE_MANAGER_OSAH role.
   * @summary Create safety equipment
   * @param {string} company
   * @param {SafetyEquipmentDto} safetyEquipmentDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SafetyEquipmentApi
   */
  public createSafetyEquipment(company: string, safetyEquipmentDto: SafetyEquipmentDto, options?: RawAxiosRequestConfig) {
    return SafetyEquipmentApiFp(this.configuration)
      .createSafetyEquipment(company, safetyEquipmentDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * The purpose of this method is to provide safety equipment for given company. Available only to SCOPE_MANAGER_OSAH role.
   * @summary Get safety equipment for given company
   * @param {string} safetyEquipment
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SafetyEquipmentApi
   */
  public getSafetyEquipment(safetyEquipment: string, options?: RawAxiosRequestConfig) {
    return SafetyEquipmentApiFp(this.configuration)
      .getSafetyEquipment(safetyEquipment, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * The purpose of this method is to provide list of all safety equipments. Available only to SCOPE_MANAGER_OSAH role.
   * @summary Get all safety equipments for given company
   * @param {string} company
   * @param {string} [q]
   * @param {QuerySafetyEquipmentStateEnum} [state]
   * @param {boolean} [nameOnly]
   * @param {number} [page] Zero-based page index (0..N)
   * @param {number} [size] The size of the page to be returned
   * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SafetyEquipmentApi
   */
  public querySafetyEquipment(
    company: string,
    q?: string,
    state?: QuerySafetyEquipmentStateEnum,
    nameOnly?: boolean,
    page?: number,
    size?: number,
    sort?: Array<string>,
    options?: RawAxiosRequestConfig
  ) {
    return SafetyEquipmentApiFp(this.configuration)
      .querySafetyEquipment(company, q, state, nameOnly, page, size, sort, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * The purpose of this method is to update safety equipment. Available only to SCOPE_MANAGER_OSAH role.
   * @summary Update safety equipment for given company
   * @param {string} safetyEquipment
   * @param {SafetyEquipmentDto} safetyEquipmentDto
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SafetyEquipmentApi
   */
  public updateSafetyEquipment(safetyEquipment: string, safetyEquipmentDto: SafetyEquipmentDto, options?: RawAxiosRequestConfig) {
    return SafetyEquipmentApiFp(this.configuration)
      .updateSafetyEquipment(safetyEquipment, safetyEquipmentDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const QuerySafetyEquipmentStateEnum = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
} as const;
export type QuerySafetyEquipmentStateEnum = (typeof QuerySafetyEquipmentStateEnum)[keyof typeof QuerySafetyEquipmentStateEnum];
